import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';
import { events } from '@estee/elc-service-bus';

export interface ISearchProductsQueried {
    searchTerm: string;
    searchType?: string;
    productIds?: string[];
    sourceId?: string;
}
export class SearchProductsQueriedUseCase {
    private eventRepository: EventRepository;
    private searchTerm: string;
    private searchType: string;
    private productIds: string[];
    private sourceId: string;

    constructor(payload: ISearchProductsQueried) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.searchTerm = payload.searchTerm;
        this.searchType = payload.searchType || 'standard';
        this.productIds = payload.productIds || [];
        this.sourceId = payload.sourceId || '';
    }

    public execute = async () => {
        let location = `?search=${this.searchTerm}&searchtype=${this.searchType}`;

        if (this.searchType === 'predictive') {
            location = `/searchresultsoverlay${location}`;
        } else {
            location = `/search${location}`;
        }

        const productImpressionsPayload = {
            productIds: this.productIds,
            listOverride: location
        };

        const searchProductsQueriedPayload = {
            location: location,
            search_keyword: this.searchTerm,
            search_type: this.searchType,
            search_results: this.productIds.length.toString(),
            site_search_results_found: this.productIds.length ? 'yes' : 'no',
            Number_of_On_Site_Searches: '1',
            attraqt_responseId: this.sourceId
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.SEARCH_PRODUCTS_QUERIED,
            type: 'link',
            payload: searchProductsQueriedPayload,
            data: {
                productImpressions: productImpressionsPayload
            }
        });
        this.eventRepository.addEventToQueue(newEvent);
    };
}
